import { Component, inject, OnInit } from '@angular/core';
import { PageHeaderComponent } from '../../../shared/components/page-header/page-header.component';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { MenubarModule } from 'primeng/menubar';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { TabsModule } from 'primeng/tabs';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-account-menu',
  imports: [
    PageHeaderComponent,
    TranslocoModule,
    MenubarModule,
    RouterOutlet,
    TabsModule,
    RouterLink,
  ],
  templateUrl: './account-menu.component.html',
  styleUrl: './account-menu.component.scss',
  standalone: true,
})
export class AccountMenuComponent implements OnInit {
  private translocoService = inject(TranslocoService);
  router = inject(Router);
  tabs: { label: string; icon: string; route: string }[] = [];

  ngOnInit() {
    this.initializeTabList();
  }
  private async initializeTabList() {
    this.tabs = [
      {
        label: await firstValueFrom(
          this.translocoService.selectTranslate('accountMenu.profile'),
        ),
        icon: 'pi pi-user',
        route: 'profile',
      },
      {
        label: await firstValueFrom(
          this.translocoService.selectTranslate('accountMenu.company'),
        ),
        icon: 'pi pi-home',
        route: 'company',
      },
      {
        label: await firstValueFrom(
          this.translocoService.selectTranslate('accountMenu.users'),
        ),
        icon: 'pi pi-users',
        route: 'users',
      },
      {
        label: await firstValueFrom(
          this.translocoService.selectTranslate('accountMenu.billing'),
        ),
        icon: 'pi pi-credit-card',
        route: 'billing',
      },
    ];
  }
  get currentTab() {
    switch (true) {
      case this.router.url.includes('users'):
        return 'users';
      case this.router.url.includes('company'):
        return 'company';
      case this.router.url.includes('billing'):
        return 'billing';
      default:
        return 'profile';
    }
  }
}
